import {
  doGetQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { MOTIVO_IMPORTACAO_SEM_COBERTURA_CAMBIAL_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    MOTIVO_IMPORTACAO_SEM_COBERTURA_CAMBIAL_ENDPOINT
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    MOTIVO_IMPORTACAO_SEM_COBERTURA_CAMBIAL_ENDPOINT,
    id
  ]);
}
